import React, { useState, useEffect } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';

import List from '@mui/material/List';

import nc1 from '../../img/dster-webp/nc1.webp';
import Toolbar from '@mui/material/Toolbar';

import DarkMode from '../DarkMode/DarkMode';
import dwhite from '../../img/dster-webp/dwhite.webp'
import ddark from '../../img/dster-webp/d.dark.webp'
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Sidebarnew.css'
import Avatar from '@mui/material/Avatar';

import Paper from '@mui/material/Paper';
import bell from '../../img/dster-webp/bell.webp'
import Badge from '@mui/material/Badge';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { useTheme, useMediaQuery, Button } from '@mui/material';
import LogoutIcon from "@mui/icons-material/Logout";

import PersonIcon from "@mui/icons-material/Person";

import Menu from "@mui/material/Menu";
import LoginIcon from '@mui/icons-material/Login';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Axios from '../../Axios'
import Album2 from "../../img/dster-webp/bs4.webp";
import Skeleton from "@mui/material/Skeleton";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));



const drawerWidth = 300;


// function SidebarNew({ prf, name, setName, title, audiosource, data, userName }) {
function SidebarNew(props) {

    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [isClosing, setIsClosing] = React.useState(false);
    const [profileData, setProfileData] = useState({});
    const [UseId, setUseId] = useState('');
    const [memo, setMemo] = useState({});

    const loader = localStorage.getItem('loader')
    // console.log(typeof loader, loader, 'loader');
    const navigate = useNavigate()

    const [isActive, setIsActive] = useState(true);
    const redirectPath = '/login'
    const timeoutSeconds = 10 * 60 * 1000


    useEffect(() => {
        screenInactive()
    }, [timeoutSeconds, isActive, navigate, redirectPath]);

    const screenInactive = () => {
        let timeoutId;

        const resetTimeout = () => {
            clearTimeout(timeoutId);
            if (isActive) {
                timeoutId = setTimeout(async () => {
                    // const session = await logout()
                    // if (session) {
                    localStorage.clear();
                    navigate(`/login`)
                    // }
                }, timeoutSeconds);
            }
        };

        const handleMouseActivity = () => {
            setIsActive(true);
            resetTimeout();
        };


        resetTimeout();


        window.addEventListener('mousemove', handleMouseActivity);
        window.addEventListener('keydown', handleMouseActivity);


        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('mousemove', handleMouseActivity);
            window.removeEventListener('keydown', handleMouseActivity);
        };
    }

    const getProDetailes = async () => {

        const objData = await JSON.parse(localStorage.getItem('proDet'));
        setMemo(objData);
        setUseId(localStorage.getItem('usrId'));
    }

    useEffect(() => {
        getProDetailes();
    }, [props?.title]);

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const mobileView = useMediaQuery(theme.breakpoints.up('sm'));
    const location = useLocation();
    const currentPath = location.pathname;

    // console.log(path.pathname, 'path');

    const paths = ['/creators', '/livechat', '/bckpassnew', '/bckpasscreate']
    const isMatchingPath = paths.some(path => currentPath === path)
    const [signIn, setSignIn] = useState(false)
    const token = localStorage.getItem("iphephile")
    const [notify, setNotify] = useState(0);


    const handleSignIn = () => {
        // setSignIn(true)
        // console.log('signIn');

        navigate('/login')
    }

    const handleSignUp = () => {
        // setSignIn(true)
        navigate('/register')
    }

    const getNotification = async () => {
        try {
            const datas = await Axios.post(
                "/notification/get_my_notification",
                { type: "count" },
                {
                    headers: {
                        Authorization: token,
                    },
                }
            )
                .then((res) => {
                    if (res?.data?.success) {
                        setNotify(res?.data?.result[0]?.count);
                    } else {
                        setNotify(0);
                    }
                })
                .catch((err) => {
                    setNotify(0);
                });
        } catch (error) {
            setNotify(0);
        }
    };

    // console.log(notify, 'notify');


    const getProfile = async () => {
        try {
            await Axios.get(`/profile/getprofile`, {
                headers: {
                    Authorization: token,
                },
            })
                .then((res) => {
                    if (res?.data?.success) {
                        setProfileData(res?.data?.result);
                    } else {
                        // toast.error("Can't Fetch Detail");
                    }
                })
                .catch((err) => {
                    // console.log(err);
                });
        } catch (error) {
            // console.log(error);
        }
    };

    useEffect(() => {
        if (token !== null) {
            getProfile();
            getNotification()
        }
    }, [props?.prf, props?.userName]);

    const login = () => {
        toast.error('Login to Continue')
        setTimeout(() => {
            navigate('/login')
        }, 1000)
    }


    const [showMessage, setShowMessage] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setShowMessage(false);
        }, 3000);

        return () => clearTimeout(timeout);
    }, [showMessage]);

    const drawer = (
        <div className='new-side'>
            {/* <DarkMode /> */}
            <List>
                <div className="headnew-logo">
                    {
                        loader == true ?
                            <>
                                {/* <div className="betalogo">
                                    <img src={beta} />
                                </div> */}
                                <div className="header-logo">
                                    <img src={localStorage.getItem("theme") === 'true' ? ddark : dwhite} alt="logo" />
                                </div>
                                <DarkMode />
                            </>
                            :
                            <>
                                <NavLink to="/">
                                    {/* <div className="betalogo">
                                        <img src={beta} />
                                    </div> */}
                                    <div className="header-logo">
                                        <img src={localStorage.getItem("theme") === 'true' ? ddark : dwhite} alt="logo" />
                                    </div>
                                </NavLink>
                                <DarkMode />
                            </>

                    }
                </div>
            </List>

            {/* <Toolbar /> */}
            <div className='discover'>
                Discover
            </div>
            <Divider className='divider' />
            <List>
                {/* <NavLink to="/explorenew2" className={({ isActive }) => (isActive ? "newsideactive" : "newsideno-active")}>
                    <div className='newsidetext btn'>
                        <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5 1H2.5C1.67157 1 1 1.67157 1 2.5V19C1 19.8284 1.67157 20.5 2.5 20.5H14.5C15.3284 20.5 16 19.8284 16 19V2.5C16 1.67157 15.3284 1 14.5 1Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.375 16.75H9.625" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>


                        Explore
                    </div>
                </NavLink> */}
                {
                    localStorage.getItem('role') == 'user' ? <></> :
                        token ?
                            loader == 'true' ?
                                < div className='display-1 newsidetext btn'>
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.49984 8.38835C10.6781 8.38835 12.444 6.62248 12.444 4.44417C12.444 2.26587 10.6781 0.5 8.49984 0.5C6.32153 0.5 4.55566 2.26587 4.55566 4.44417C4.55566 6.62248 6.32153 8.38835 8.49984 8.38835Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16 16.2767C15.4905 14.688 14.4897 13.3021 13.1417 12.3188C11.7938 11.3355 10.1685 10.8057 8.5 10.8057C6.83155 10.8057 5.2062 11.3355 3.85827 12.3188C2.51035 13.3021 1.50949 14.688 1 16.2767H16Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                    Create
                                </div> :
                                <NavLink to="/creators" className={({ isActive }) => (isActive ? "newsideactive" : "newsideno-active")}>
                                    <div className='display-1 newsidetext btn'>
                                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.49984 8.38835C10.6781 8.38835 12.444 6.62248 12.444 4.44417C12.444 2.26587 10.6781 0.5 8.49984 0.5C6.32153 0.5 4.55566 2.26587 4.55566 4.44417C4.55566 6.62248 6.32153 8.38835 8.49984 8.38835Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M16 16.2767C15.4905 14.688 14.4897 13.3021 13.1417 12.3188C11.7938 11.3355 10.1685 10.8057 8.5 10.8057C6.83155 10.8057 5.2062 11.3355 3.85827 12.3188C2.51035 13.3021 1.50949 14.688 1 16.2767H16Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                        Create
                                    </div>
                                </NavLink>
                            :
                            <div className='display-1 newsidetext btn' onClick={() => { login() }}>
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.49984 8.38835C10.6781 8.38835 12.444 6.62248 12.444 4.44417C12.444 2.26587 10.6781 0.5 8.49984 0.5C6.32153 0.5 4.55566 2.26587 4.55566 4.44417C4.55566 6.62248 6.32153 8.38835 8.49984 8.38835Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16 16.2767C15.4905 14.688 14.4897 13.3021 13.1417 12.3188C11.7938 11.3355 10.1685 10.8057 8.5 10.8057C6.83155 10.8057 5.2062 11.3355 3.85827 12.3188C2.51035 13.3021 1.50949 14.688 1 16.2767H16Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                Create
                            </div>
                }

                {/* <NavLink to="/playernew" className={({ isActive }) => (isActive ? "newsideactive" : "newsideno-active")}> */}
                <NavLink to="/" className={({ isActive }) => (isActive ? "newsideactive" : "newsideno-active")}>
                    <div className='display-1 newsidetext btn'>
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.61538 0.5H2.15385C1.51659 0.5 1 1.01659 1 1.65385V5.11538C1 5.75264 1.51659 6.26923 2.15385 6.26923H5.61538C6.25264 6.26923 6.76923 5.75264 6.76923 5.11538V1.65385C6.76923 1.01659 6.25264 0.5 5.61538 0.5Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M14.8459 0.5H11.3843C10.7471 0.5 10.2305 1.01659 10.2305 1.65385V5.11538C10.2305 5.75264 10.7471 6.26923 11.3843 6.26923H14.8459C15.4831 6.26923 15.9997 5.75264 15.9997 5.11538V1.65385C15.9997 1.01659 15.4831 0.5 14.8459 0.5Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M5.61538 9.73047H2.15385C1.51659 9.73047 1 10.2471 1 10.8843V14.3459C1 14.9831 1.51659 15.4997 2.15385 15.4997H5.61538C6.25264 15.4997 6.76923 14.9831 6.76923 14.3459V10.8843C6.76923 10.2471 6.25264 9.73047 5.61538 9.73047Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M14.8459 9.73047H11.3843C10.7471 9.73047 10.2305 10.2471 10.2305 10.8843V14.3459C10.2305 14.9831 10.7471 15.4997 11.3843 15.4997H14.8459C15.4831 15.4997 15.9997 14.9831 15.9997 14.3459V10.8843C15.9997 10.2471 15.4831 9.73047 14.8459 9.73047Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Player
                    </div>
                </NavLink>
                {
                    token ?
                        loader == 'true' ?
                            <div className='display-1 newsidetext btn'>
                                <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.50472 13.018L2.13916 7.25207C-1.32038 3.79253 3.76514 -2.84979 8.50472 2.52403C13.2443 -2.84979 18.3068 3.81559 14.8703 7.25207L8.50472 13.018Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Library
                            </div> :
                            <NavLink to="/playlist" className={({ isActive }) => (isActive ? "newsideactive" : "newsideno-active")}>
                                <div className='display-1 newsidetext btn'>
                                    <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.50472 13.018L2.13916 7.25207C-1.32038 3.79253 3.76514 -2.84979 8.50472 2.52403C13.2443 -2.84979 18.3068 3.81559 14.8703 7.25207L8.50472 13.018Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Library
                                </div>
                            </NavLink> :
                        <div className='display-1 newsidetext btn' onClick={() => { login() }}>
                            <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.50472 13.018L2.13916 7.25207C-1.32038 3.79253 3.76514 -2.84979 8.50472 2.52403C13.2443 -2.84979 18.3068 3.81559 14.8703 7.25207L8.50472 13.018Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Library
                        </div>
                }
                {
                    // token ?
                    loader == 'true' ?
                        <div className='display-1 newsidetext btn'>
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.32692 7.99955C5.64555 7.99955 5.90385 7.74125 5.90385 7.42263C5.90385 7.104 5.64555 6.8457 5.32692 6.8457C5.0083 6.8457 4.75 7.104 4.75 7.42263C4.75 7.74125 5.0083 7.99955 5.32692 7.99955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.07692 7.99955C9.39555 7.99955 9.65385 7.74125 9.65385 7.42263C9.65385 7.104 9.39555 6.8457 9.07692 6.8457C8.7583 6.8457 8.5 7.104 8.5 7.42263C8.5 7.74125 8.7583 7.99955 9.07692 7.99955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12.8269 7.99955C13.1455 7.99955 13.4038 7.74125 13.4038 7.42263C13.4038 7.104 13.1455 6.8457 12.8269 6.8457C12.5083 6.8457 12.25 7.104 12.25 7.42263C12.25 7.74125 12.5083 7.99955 12.8269 7.99955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.61538 14.3462L1 15.5L2.15385 12.0385V1.65385C2.15385 1.34783 2.27541 1.05434 2.4918 0.837954C2.70819 0.621566 3.00167 0.5 3.30769 0.5H14.8462C15.1522 0.5 15.4457 0.621566 15.662 0.837954C15.8784 1.05434 16 1.34783 16 1.65385V13.1923C16 13.4983 15.8784 13.7918 15.662 14.0082C15.4457 14.2246 15.1522 14.3462 14.8462 14.3462H5.61538Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Live Chat
                            <Stack direction="row" spacing={-1} className='ava-grp'>
                                <Avatar alt="Remy Sharp" src="https://imgs.search.brave.com/yugGzJcNDEopwgUwvoIQNG9ya5_CNAJ8ACjBovfM1e0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/dGhlYXRobGV0aWMu/Y29tL2FwcC91cGxv/YWRzLzIwMjQvMDcv/MDYwOTQxMjIvR2V0/dHlJbWFnZXMtMjE1/OTI3NTg4Ni1zY2Fs/ZWQuanBn" sx={{ width: 20, height: 20 }} />
                                <Avatar alt="Travis Howard" src="https://imgs.search.brave.com/yugGzJcNDEopwgUwvoIQNG9ya5_CNAJ8ACjBovfM1e0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/dGhlYXRobGV0aWMu/Y29tL2FwcC91cGxv/YWRzLzIwMjQvMDcv/MDYwOTQxMjIvR2V0/dHlJbWFnZXMtMjE1/OTI3NTg4Ni1zY2Fs/ZWQuanBn" sx={{ width: 20, height: 20 }} />
                                <Avatar alt="Cindy Baker" src="https://imgs.search.brave.com/yugGzJcNDEopwgUwvoIQNG9ya5_CNAJ8ACjBovfM1e0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/dGhlYXRobGV0aWMu/Y29tL2FwcC91cGxv/YWRzLzIwMjQvMDcv/MDYwOTQxMjIvR2V0/dHlJbWFnZXMtMjE1/OTI3NTg4Ni1zY2Fs/ZWQuanBn" sx={{ width: 20, height: 20 }} />

                            </Stack>
                        </div> :
                        <NavLink to="/livechat" className={({ isActive }) => (isActive ? "newsideactive" : "newsideno-active")}>
                            <div className='display-1 newsidetext btn'>
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.32692 7.99955C5.64555 7.99955 5.90385 7.74125 5.90385 7.42263C5.90385 7.104 5.64555 6.8457 5.32692 6.8457C5.0083 6.8457 4.75 7.104 4.75 7.42263C4.75 7.74125 5.0083 7.99955 5.32692 7.99955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.07692 7.99955C9.39555 7.99955 9.65385 7.74125 9.65385 7.42263C9.65385 7.104 9.39555 6.8457 9.07692 6.8457C8.7583 6.8457 8.5 7.104 8.5 7.42263C8.5 7.74125 8.7583 7.99955 9.07692 7.99955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.8269 7.99955C13.1455 7.99955 13.4038 7.74125 13.4038 7.42263C13.4038 7.104 13.1455 6.8457 12.8269 6.8457C12.5083 6.8457 12.25 7.104 12.25 7.42263C12.25 7.74125 12.5083 7.99955 12.8269 7.99955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5.61538 14.3462L1 15.5L2.15385 12.0385V1.65385C2.15385 1.34783 2.27541 1.05434 2.4918 0.837954C2.70819 0.621566 3.00167 0.5 3.30769 0.5H14.8462C15.1522 0.5 15.4457 0.621566 15.662 0.837954C15.8784 1.05434 16 1.34783 16 1.65385V13.1923C16 13.4983 15.8784 13.7918 15.662 14.0082C15.4457 14.2246 15.1522 14.3462 14.8462 14.3462H5.61538Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Live Chat
                                <Stack direction="row" spacing={-1} className='ava-grp'>
                                    <Avatar alt="Remy Sharp" src="https://imgs.search.brave.com/yugGzJcNDEopwgUwvoIQNG9ya5_CNAJ8ACjBovfM1e0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/dGhlYXRobGV0aWMu/Y29tL2FwcC91cGxv/YWRzLzIwMjQvMDcv/MDYwOTQxMjIvR2V0/dHlJbWFnZXMtMjE1/OTI3NTg4Ni1zY2Fs/ZWQuanBn" sx={{ width: 20, height: 20 }} />
                                    <Avatar alt="Travis Howard" src="https://imgs.search.brave.com/yugGzJcNDEopwgUwvoIQNG9ya5_CNAJ8ACjBovfM1e0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/dGhlYXRobGV0aWMu/Y29tL2FwcC91cGxv/YWRzLzIwMjQvMDcv/MDYwOTQxMjIvR2V0/dHlJbWFnZXMtMjE1/OTI3NTg4Ni1zY2Fs/ZWQuanBn" sx={{ width: 20, height: 20 }} />
                                    <Avatar alt="Cindy Baker" src="https://imgs.search.brave.com/yugGzJcNDEopwgUwvoIQNG9ya5_CNAJ8ACjBovfM1e0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/dGhlYXRobGV0aWMu/Y29tL2FwcC91cGxv/YWRzLzIwMjQvMDcv/MDYwOTQxMjIvR2V0/dHlJbWFnZXMtMjE1/OTI3NTg4Ni1zY2Fs/ZWQuanBn" sx={{ width: 20, height: 20 }} />

                                </Stack>
                            </div>
                        </NavLink>
                    // :
                    // <div className='display-1 newsidetext btn' onClick={() => { login() }}>
                    //     <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //         <path d="M5.32692 7.99955C5.64555 7.99955 5.90385 7.74125 5.90385 7.42263C5.90385 7.104 5.64555 6.8457 5.32692 6.8457C5.0083 6.8457 4.75 7.104 4.75 7.42263C4.75 7.74125 5.0083 7.99955 5.32692 7.99955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                    //         <path d="M9.07692 7.99955C9.39555 7.99955 9.65385 7.74125 9.65385 7.42263C9.65385 7.104 9.39555 6.8457 9.07692 6.8457C8.7583 6.8457 8.5 7.104 8.5 7.42263C8.5 7.74125 8.7583 7.99955 9.07692 7.99955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                    //         <path d="M12.8269 7.99955C13.1455 7.99955 13.4038 7.74125 13.4038 7.42263C13.4038 7.104 13.1455 6.8457 12.8269 6.8457C12.5083 6.8457 12.25 7.104 12.25 7.42263C12.25 7.74125 12.5083 7.99955 12.8269 7.99955Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                    //         <path d="M5.61538 14.3462L1 15.5L2.15385 12.0385V1.65385C2.15385 1.34783 2.27541 1.05434 2.4918 0.837954C2.70819 0.621566 3.00167 0.5 3.30769 0.5H14.8462C15.1522 0.5 15.4457 0.621566 15.662 0.837954C15.8784 1.05434 16 1.34783 16 1.65385V13.1923C16 13.4983 15.8784 13.7918 15.662 14.0082C15.4457 14.2246 15.1522 14.3462 14.8462 14.3462H5.61538Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                    //     </svg>
                    //     Live Chat
                    //     <Stack direction="row" spacing={-1} className='ava-grp'>
                    //         <Avatar alt="Remy Sharp" src="https://imgs.search.brave.com/yugGzJcNDEopwgUwvoIQNG9ya5_CNAJ8ACjBovfM1e0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/dGhlYXRobGV0aWMu/Y29tL2FwcC91cGxv/YWRzLzIwMjQvMDcv/MDYwOTQxMjIvR2V0/dHlJbWFnZXMtMjE1/OTI3NTg4Ni1zY2Fs/ZWQuanBn" sx={{ width: 20, height: 20 }} />
                    //         <Avatar alt="Travis Howard" src="https://imgs.search.brave.com/yugGzJcNDEopwgUwvoIQNG9ya5_CNAJ8ACjBovfM1e0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/dGhlYXRobGV0aWMu/Y29tL2FwcC91cGxv/YWRzLzIwMjQvMDcv/MDYwOTQxMjIvR2V0/dHlJbWFnZXMtMjE1/OTI3NTg4Ni1zY2Fs/ZWQuanBn" sx={{ width: 20, height: 20 }} />
                    //         <Avatar alt="Cindy Baker" src="https://imgs.search.brave.com/yugGzJcNDEopwgUwvoIQNG9ya5_CNAJ8ACjBovfM1e0/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9jZG4u/dGhlYXRobGV0aWMu/Y29tL2FwcC91cGxv/YWRzLzIwMjQvMDcv/MDYwOTQxMjIvR2V0/dHlJbWFnZXMtMjE1/OTI3NTg4Ni1zY2Fs/ZWQuanBn" sx={{ width: 20, height: 20 }} />

                    //     </Stack>
                    // </div>
                }
                {/* <NavLink to="/feed" className={({ isActive }) => (isActive ? "newsideactive" : "newsideno-active")}>
                    <div className='display-1 newsidetext btn'>
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.19186 5.69231C7.62567 5.69231 8.78801 4.52997 8.78801 3.09615C8.78801 1.66234 7.62567 0.5 6.19186 0.5C4.75804 0.5 3.5957 1.66234 3.5957 3.09615C3.5957 4.52997 4.75804 5.69231 6.19186 5.69231Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.3846 14.3462H1V13.1923C1 11.8152 1.54705 10.4945 2.52079 9.52079C3.49454 8.54705 4.81522 8 6.19231 8C7.56939 8 8.89008 8.54705 9.86382 9.52079C10.8376 10.4945 11.3846 11.8152 11.3846 13.1923V14.3462Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.80762 0.5C10.4962 0.5 11.1565 0.773523 11.6434 1.2604C12.1302 1.74727 12.4038 2.40761 12.4038 3.09615C12.4038 3.7847 12.1302 4.44504 11.6434 4.93191C11.1565 5.41879 10.4962 5.69231 9.80762 5.69231" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.6543 8.21875C12.6372 8.59265 13.4834 9.25619 14.0809 10.1215C14.6784 10.9869 14.9991 12.0133 15.0005 13.0649V14.3457H13.2697" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Friends
                    </div>
                </NavLink> */}
                {
                    // localStorage.getItem('role') == 'user' ? <></> :
                    // token ?
                    loader == 'true' ?
                        <div className='display-1 newsidetext btn'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 13 13" fill="none">
                                <path d="M4.46875 4.0625C4.36101 4.0625 4.25767 4.1053 4.18149 4.18149C4.1053 4.25767 4.0625 4.36101 4.0625 4.46875C4.0625 4.57649 4.1053 4.67983 4.18149 4.75601C4.25767 4.8322 4.36101 4.875 4.46875 4.875H8.53125C8.63899 4.875 8.74233 4.8322 8.81851 4.75601C8.8947 4.67983 8.9375 4.57649 8.9375 4.46875C8.9375 4.36101 8.8947 4.25767 8.81851 4.18149C8.74233 4.1053 8.63899 4.0625 8.53125 4.0625H4.46875ZM4.46875 5.6875C4.36101 5.6875 4.25767 5.7303 4.18149 5.80649C4.1053 5.88267 4.0625 5.98601 4.0625 6.09375C4.0625 6.20149 4.1053 6.30483 4.18149 6.38101C4.25767 6.4572 4.36101 6.5 4.46875 6.5H6.90625C7.01399 6.5 7.11733 6.4572 7.19351 6.38101C7.2697 6.30483 7.3125 6.20149 7.3125 6.09375C7.3125 5.98601 7.2697 5.88267 7.19351 5.80649C7.11733 5.7303 7.01399 5.6875 6.90625 5.6875H4.46875Z" fill="#B8B8B8" />
                                <path d="M6.5 1.625C6.93098 1.625 7.3443 1.4538 7.64905 1.14905C7.95379 0.844302 8.125 0.430977 8.125 0H10.1562C10.4795 0 10.7895 0.128404 11.018 0.356964C11.2466 0.585524 11.375 0.895517 11.375 1.21875V11.7812C11.375 12.1045 11.2466 12.4145 11.018 12.643C10.7895 12.8716 10.4795 13 10.1562 13H2.84375C2.52052 13 2.21052 12.8716 1.98196 12.643C1.7534 12.4145 1.625 12.1045 1.625 11.7812V1.21875C1.625 0.895517 1.7534 0.585524 1.98196 0.356964C2.21052 0.128404 2.52052 0 2.84375 0L4.875 0C4.875 0.430977 5.0462 0.844302 5.35095 1.14905C5.6557 1.4538 6.06902 1.625 6.5 1.625ZM6.5 2.4375C5.99572 2.43776 5.50377 2.28162 5.09195 1.99058C4.68013 1.69954 4.36872 1.28794 4.20062 0.8125H2.84375C2.73601 0.8125 2.63267 0.855301 2.55649 0.931488C2.4803 1.00767 2.4375 1.11101 2.4375 1.21875V11.7812C2.4375 11.889 2.4803 11.9923 2.55649 12.0685C2.63267 12.1447 2.73601 12.1875 2.84375 12.1875H10.1562C10.264 12.1875 10.3673 12.1447 10.4435 12.0685C10.5197 11.9923 10.5625 11.889 10.5625 11.7812V1.21875C10.5625 1.11101 10.5197 1.00767 10.4435 0.931488C10.3673 0.855301 10.264 0.8125 10.1562 0.8125H8.79938C8.63128 1.28794 8.31987 1.69954 7.90805 1.99058C7.49623 2.28162 7.00428 2.43776 6.5 2.4375Z" fill="#B8B8B8" />
                            </svg>
                            Backstage Pass
                        </div> :
                        <NavLink to="/bckpassnew" className={({ isActive }) => (isActive ? "newsideactive" : "newsideno-active")}>
                            <div className='display-1 newsidetext btn'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 13 13" fill="none">
                                    <path d="M4.46875 4.0625C4.36101 4.0625 4.25767 4.1053 4.18149 4.18149C4.1053 4.25767 4.0625 4.36101 4.0625 4.46875C4.0625 4.57649 4.1053 4.67983 4.18149 4.75601C4.25767 4.8322 4.36101 4.875 4.46875 4.875H8.53125C8.63899 4.875 8.74233 4.8322 8.81851 4.75601C8.8947 4.67983 8.9375 4.57649 8.9375 4.46875C8.9375 4.36101 8.8947 4.25767 8.81851 4.18149C8.74233 4.1053 8.63899 4.0625 8.53125 4.0625H4.46875ZM4.46875 5.6875C4.36101 5.6875 4.25767 5.7303 4.18149 5.80649C4.1053 5.88267 4.0625 5.98601 4.0625 6.09375C4.0625 6.20149 4.1053 6.30483 4.18149 6.38101C4.25767 6.4572 4.36101 6.5 4.46875 6.5H6.90625C7.01399 6.5 7.11733 6.4572 7.19351 6.38101C7.2697 6.30483 7.3125 6.20149 7.3125 6.09375C7.3125 5.98601 7.2697 5.88267 7.19351 5.80649C7.11733 5.7303 7.01399 5.6875 6.90625 5.6875H4.46875Z" fill="#B8B8B8" />
                                    <path d="M6.5 1.625C6.93098 1.625 7.3443 1.4538 7.64905 1.14905C7.95379 0.844302 8.125 0.430977 8.125 0H10.1562C10.4795 0 10.7895 0.128404 11.018 0.356964C11.2466 0.585524 11.375 0.895517 11.375 1.21875V11.7812C11.375 12.1045 11.2466 12.4145 11.018 12.643C10.7895 12.8716 10.4795 13 10.1562 13H2.84375C2.52052 13 2.21052 12.8716 1.98196 12.643C1.7534 12.4145 1.625 12.1045 1.625 11.7812V1.21875C1.625 0.895517 1.7534 0.585524 1.98196 0.356964C2.21052 0.128404 2.52052 0 2.84375 0L4.875 0C4.875 0.430977 5.0462 0.844302 5.35095 1.14905C5.6557 1.4538 6.06902 1.625 6.5 1.625ZM6.5 2.4375C5.99572 2.43776 5.50377 2.28162 5.09195 1.99058C4.68013 1.69954 4.36872 1.28794 4.20062 0.8125H2.84375C2.73601 0.8125 2.63267 0.855301 2.55649 0.931488C2.4803 1.00767 2.4375 1.11101 2.4375 1.21875V11.7812C2.4375 11.889 2.4803 11.9923 2.55649 12.0685C2.63267 12.1447 2.73601 12.1875 2.84375 12.1875H10.1562C10.264 12.1875 10.3673 12.1447 10.4435 12.0685C10.5197 11.9923 10.5625 11.889 10.5625 11.7812V1.21875C10.5625 1.11101 10.5197 1.00767 10.4435 0.931488C10.3673 0.855301 10.264 0.8125 10.1562 0.8125H8.79938C8.63128 1.28794 8.31987 1.69954 7.90805 1.99058C7.49623 2.28162 7.00428 2.43776 6.5 2.4375Z" fill="#B8B8B8" />
                                </svg>
                                Backstage Pass
                            </div>
                        </NavLink>
                    // :
                    // <div className='display-1 newsidetext btn' onClick={() => { login() }}>
                    //     <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 13 13" fill="none">
                    //         <path d="M4.46875 4.0625C4.36101 4.0625 4.25767 4.1053 4.18149 4.18149C4.1053 4.25767 4.0625 4.36101 4.0625 4.46875C4.0625 4.57649 4.1053 4.67983 4.18149 4.75601C4.25767 4.8322 4.36101 4.875 4.46875 4.875H8.53125C8.63899 4.875 8.74233 4.8322 8.81851 4.75601C8.8947 4.67983 8.9375 4.57649 8.9375 4.46875C8.9375 4.36101 8.8947 4.25767 8.81851 4.18149C8.74233 4.1053 8.63899 4.0625 8.53125 4.0625H4.46875ZM4.46875 5.6875C4.36101 5.6875 4.25767 5.7303 4.18149 5.80649C4.1053 5.88267 4.0625 5.98601 4.0625 6.09375C4.0625 6.20149 4.1053 6.30483 4.18149 6.38101C4.25767 6.4572 4.36101 6.5 4.46875 6.5H6.90625C7.01399 6.5 7.11733 6.4572 7.19351 6.38101C7.2697 6.30483 7.3125 6.20149 7.3125 6.09375C7.3125 5.98601 7.2697 5.88267 7.19351 5.80649C7.11733 5.7303 7.01399 5.6875 6.90625 5.6875H4.46875Z" fill="#B8B8B8" />
                    //         <path d="M6.5 1.625C6.93098 1.625 7.3443 1.4538 7.64905 1.14905C7.95379 0.844302 8.125 0.430977 8.125 0H10.1562C10.4795 0 10.7895 0.128404 11.018 0.356964C11.2466 0.585524 11.375 0.895517 11.375 1.21875V11.7812C11.375 12.1045 11.2466 12.4145 11.018 12.643C10.7895 12.8716 10.4795 13 10.1562 13H2.84375C2.52052 13 2.21052 12.8716 1.98196 12.643C1.7534 12.4145 1.625 12.1045 1.625 11.7812V1.21875C1.625 0.895517 1.7534 0.585524 1.98196 0.356964C2.21052 0.128404 2.52052 0 2.84375 0L4.875 0C4.875 0.430977 5.0462 0.844302 5.35095 1.14905C5.6557 1.4538 6.06902 1.625 6.5 1.625ZM6.5 2.4375C5.99572 2.43776 5.50377 2.28162 5.09195 1.99058C4.68013 1.69954 4.36872 1.28794 4.20062 0.8125H2.84375C2.73601 0.8125 2.63267 0.855301 2.55649 0.931488C2.4803 1.00767 2.4375 1.11101 2.4375 1.21875V11.7812C2.4375 11.889 2.4803 11.9923 2.55649 12.0685C2.63267 12.1447 2.73601 12.1875 2.84375 12.1875H10.1562C10.264 12.1875 10.3673 12.1447 10.4435 12.0685C10.5197 11.9923 10.5625 11.889 10.5625 11.7812V1.21875C10.5625 1.11101 10.5197 1.00767 10.4435 0.931488C10.3673 0.855301 10.264 0.8125 10.1562 0.8125H8.79938C8.63128 1.28794 8.31987 1.69954 7.90805 1.99058C7.49623 2.28162 7.00428 2.43776 6.5 2.4375Z" fill="#B8B8B8" />
                    //     </svg>
                    //     Backstage Pass
                    // </div>
                }
                {/* <div className='discover'>
                    Help
                </div>
                <Divider className='divider' />
                <NavLink to="/feed" className={({ isActive }) => (isActive ? "newsideactive" : "newsideno-active")}>
                    <div className='display-1 newsidetext btn'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                            <path d="M6.27561 3.19925L6.816 1.8043C6.90714 1.56812 7.06748 1.36496 7.27602 1.22145C7.48457 1.07793 7.73159 1.00075 7.98475 1H9.01525C9.26841 1.00075 9.51543 1.07793 9.72398 1.22145C9.93252 1.36496 10.0929 1.56812 10.184 1.8043L10.7244 3.19925L12.5592 4.25489L14.0421 4.02868C14.289 3.99517 14.5404 4.03582 14.7641 4.14546C14.9879 4.25511 15.174 4.4288 15.2988 4.64448L15.8015 5.52418C15.9303 5.74328 15.9897 5.9963 15.9717 6.24983C15.9538 6.50336 15.8594 6.74549 15.701 6.94427L14.7836 8.11301V10.2243L15.7261 11.393C15.8845 11.5918 15.9789 11.8339 15.9969 12.0875C16.0148 12.341 15.9555 12.594 15.8267 12.8131L15.324 13.6928C15.1991 13.9085 15.013 14.0822 14.7893 14.1918C14.5655 14.3015 14.3142 14.3421 14.0672 14.3086L12.5843 14.0824L10.7495 15.1381L10.2091 16.533C10.118 16.7692 9.95766 16.9723 9.74911 17.1159C9.54057 17.2594 9.29354 17.3366 9.04039 17.3373H7.98475C7.73159 17.3366 7.48457 17.2594 7.27602 17.1159C7.06748 16.9723 6.90714 16.7692 6.816 16.533L6.27561 15.1381L4.44081 14.0824L2.95788 14.3086C2.71096 14.3421 2.45965 14.3015 2.23588 14.1918C2.01211 14.0822 1.82599 13.9085 1.70117 13.6928L1.19848 12.8131C1.06967 12.594 1.01032 12.341 1.02827 12.0875C1.04622 11.8339 1.14062 11.5918 1.29902 11.393L2.21642 10.2243V8.11301L1.27389 6.94427C1.11549 6.74549 1.02109 6.50336 1.00314 6.24983C0.985189 5.9963 1.04454 5.74328 1.17335 5.52418L1.67603 4.64448C1.80086 4.4288 1.98698 4.25511 2.21074 4.14546C2.43451 4.03582 2.68583 3.99517 2.93275 4.02868L4.41567 4.25489L6.27561 3.19925ZM5.98657 9.16865C5.98657 9.66576 6.13398 10.1517 6.41016 10.565C6.68634 10.9784 7.07888 11.3005 7.53815 11.4908C7.99742 11.681 8.50279 11.7308 8.99035 11.6338C9.4779 11.5368 9.92575 11.2974 10.2773 10.9459C10.6288 10.5944 10.8682 10.1466 10.9651 9.659C11.0621 9.17144 11.0123 8.66607 10.8221 8.2068C10.6319 7.74753 10.3097 7.35499 9.89639 7.07881C9.48306 6.80263 8.99711 6.65522 8.5 6.65522C7.8334 6.65522 7.1941 6.92003 6.72274 7.39139C6.25138 7.86275 5.98657 8.50205 5.98657 9.16865V9.16865Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>



                        Settings
                    </div>
                </NavLink>
                <NavLink to="/feed">
                    <div className='display-1 newsidetext btn'>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.15385 7.3457H3.30769C3.4607 7.3457 3.60744 7.40649 3.71564 7.51468C3.82383 7.62287 3.88462 7.76962 3.88462 7.92263V10.8072C3.88462 10.9603 3.82383 11.107 3.71564 11.2152C3.60744 11.3234 3.4607 11.3842 3.30769 11.3842H2.15385C1.84783 11.3842 1.55434 11.2626 1.33795 11.0462C1.12157 10.8298 1 10.5363 1 10.2303V8.49955C1 8.19353 1.12157 7.90005 1.33795 7.68366C1.55434 7.46727 1.84783 7.3457 2.15385 7.3457V7.3457Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M14.8462 11.3848H13.6923C13.5393 11.3848 13.3926 11.324 13.2844 11.2158C13.1762 11.1076 13.1154 10.9609 13.1154 10.8078V7.92323C13.1154 7.77022 13.1762 7.62347 13.2844 7.51528C13.3926 7.40709 13.5393 7.3463 13.6923 7.3463H14.8462C15.1522 7.3463 15.4457 7.46787 15.662 7.68426C15.8784 7.90065 16 8.19413 16 8.50015V10.2309C16 10.5369 15.8784 10.8304 15.662 11.0468C15.4457 11.2632 15.1522 11.3848 14.8462 11.3848V11.3848Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.3848 14.5578C11.9968 14.5578 12.5838 14.3147 13.0166 13.8819C13.4493 13.4492 13.6925 12.8622 13.6925 12.2502V11.3848" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.94261 13.1152C10.3251 13.1152 10.692 13.2672 10.9625 13.5377C11.233 13.8082 11.3849 14.175 11.3849 14.5575C11.3849 14.9401 11.233 15.3069 10.9625 15.5774C10.692 15.8479 10.3251 15.9998 9.94261 15.9998H8.21184C7.82932 15.9998 7.46246 15.8479 7.19197 15.5774C6.92149 15.3069 6.76953 14.9401 6.76953 14.5575C6.76953 14.175 6.92149 13.8082 7.19197 13.5377C7.46246 13.2672 7.82932 13.1152 8.21184 13.1152H9.94261Z" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.30762 7.34615V6.19231C3.30762 4.81522 3.85466 3.49454 4.82841 2.52079C5.80216 1.54705 7.12284 1 8.49993 1C9.87701 1 11.1977 1.54705 12.1714 2.52079C13.1452 3.49454 13.6922 4.81522 13.6922 6.19231V7.34615" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.76953 5.03809V6.76886" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.2305 5.03809V6.76886" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.76953 9.07715C6.76953 10.6118 10.2311 10.6118 10.2311 9.07715" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>




                        FAQs
                    </div>
                </NavLink> */}
                {
                    !isLgUp ? <button class="cssbuttons-io-button" onClick={handleSignIn}>
                        Sign-in
                        <div class="icon">
                            <LoginIcon />
                        </div>
                    </button> : null
                }
            </List >

        </div >
    );
    const sideHeight = localStorage.getItem("playsong")
    // console.log(sideHeight, props?.audiosource2, 'sideheight');


    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleClick2 = (event) => {
        setAnchorEl(event.currentTarget);
        getProfile()
        // setDrop(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        // setDrop(false);
    };

    const logout = () => {
        handleClose()
        localStorage.setItem("NewUser", "false")
        if (localStorage.getItem("iphephile") != null) {
            localStorage.clear();
            toast.success('Logged out Successfully', {
                duration: 3000, // Set the duration for which the toast is visible
            })

            setTimeout(() => {
                // navigate('/login')
                navigate('/')
            }, 1000)
        }
        else {
            navigate('/')
        }

    }


    return (
        <div className='sidebarnew'>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />

                <Box
                    component="nav"
                    sx={{ width: { lg: drawerWidth }, flexShrink: { sm: 0 } }}
                    aria-label="mailbox folders"
                >
                    <AppBar
                        position="fixed"
                        sx={{
                            width: { lg: `calc(100% - ${drawerWidth}px)` },
                            ml: { lg: `${drawerWidth}px` },
                        }}
                    >
                        <Toolbar className='toolbar-new'>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{ mr: 2, display: { lg: 'none' } }}

                            >
                                <button class="setting-btn">
                                    <span class="bar bar1"></span>
                                    <span class="bar bar2"></span>
                                    <span class="bar bar1"></span>
                                </button>



                            </IconButton>
                            <div style={{ width: '70%' }}>
                                <div class="group" >
                                    <svg viewBox="0 0 24 24" aria-hidden="true" class="search-icon" >
                                        <g>
                                            <path
                                                d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"
                                            ></path>
                                        </g>
                                    </svg>

                                    <input
                                        id="query"
                                        class="input2"
                                        value={props?.name}
                                        onChange={(e) => { props?.setName(e.target.value) }}
                                        type="text"
                                        placeholder="search music, artist, genre..."
                                        name="searchbar"
                                    />
                                </div>

                            </div>
                            {localStorage.getItem("iphephile") != null ?

                                <div className='display-2 recente-head-div cursor' style={{ width: isLgUp ? 'auto' : 'auto' }} >
                                    <div className='display-1 ' onClick={(e) => { if (loader == 'true') { } else { handleClick2(e) } }}>
                                        {showMessage ? (
                                            <Stack spacing={1}>
                                                <Skeleton
                                                    variant="circular"
                                                    width={50}
                                                    height={50}
                                                    sx={{
                                                        bgcolor: "var(--clr-skel)",
                                                        "@media (max-width: 575.98px)": {
                                                            width: "90px !important",
                                                            height: "90px !important",
                                                        },
                                                    }}
                                                />
                                            </Stack>
                                        ) : (
                                            <Avatar
                                                alt="Remy Sharp"
                                                src={profileData?.profilePicture ? profileData?.profilePicture : props?.prf ? props?.prf : Album2}
                                                sx={{ width: 50, height: 50 }}
                                            />
                                        )}

                                        {isLgUp && <div>
                                            <div className='recent-head-artist'>
                                                {profileData?.name ? profileData?.name : props?.userName}
                                            </div>
                                            <div className='recent-head-domain'>
                                                {profileData?.role == 'artist' ? 'Artist' : profileData?.role == 'user' ? 'Fan' : ''}
                                            </div>
                                        </div>}
                                    </div>
                                    {isLgUp && <div className='cursor'>
                                        <Badge badgeContent={notify} color="secondary" >
                                            <img src={bell} style={{ width: "25px", height: '25px' }} onClick={() => { if (loader == 'true') { } else { navigate("/notify") } }} />
                                        </Badge>

                                    </div>}
                                </div>
                                :
                                isLgUp ?
                                    <div className='logins display-1'>
                                        <Button onClick={handleSignIn}>
                                            Log-in

                                        </Button>
                                        <Button onClick={handleSignUp}>
                                            Sign-Up

                                        </Button>
                                    </div>
                                    : null}

                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                }}
                                className="profile-pop-compo"
                            >
                                <div className="profile-popup">
                                    <div
                                        className="profile-img-inner inner-dp"
                                        style={{ cursor: "pointer" }}
                                    // onClick={() => {
                                    //     navigate(`/artistpage/${profileData?._id ? profileData?._id : UseId}`);
                                    // }}
                                    >
                                        <Avatar
                                            alt="Remy Sharp"
                                            src={profileData?.profilePicture ? profileData?.profilePicture : props?.prf ? props?.prf : Album2}
                                            sx={{ width: 50, height: 50 }}
                                        />
                                    </div>
                                    <div className="popup-content-profile">
                                        {token ? <div
                                            onClick={() => {
                                                navigate(`/artistpage/${profileData?._id ? profileData?._id : UseId}`);
                                            }}
                                        >
                                            <PersonIcon /> Profile
                                        </div> : <></>}
                                        {/* <div
                                            onClick={() => {
                                                handleClose();
                                                // navigate("");
                                            }}
                                        >
                                            <CurrencyExchangeIcon />
                                            <NavLink to='https://tokenpresale.dreamster.io' target="_blank" >Buy Dreamster</NavLink>
                                        </div> */}
                                        {/* <div
                                            onClick={() => {
                                                navigate("/staking");
                                            }}
                                        >
                                            <AlternateEmailIcon /> Staking
                                        </div> */}
                                        {/* <div
                                            onClick={() => {
                                                navigate("/activity");
                                            }}
                                        >
                                            <LocalActivityIcon /> Activity
                                        </div> */}
                                        <div
                                            onClick={() => {
                                                logout();
                                            }}
                                        >
                                            <LogoutIcon /> Logout
                                        </div>
                                    </div>
                                </div>
                            </Menu>
                        </Toolbar>
                    </AppBar>
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Drawer
                        // container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onTransitionEnd={handleDrawerTransitionEnd}
                        onClose={handleDrawerClose}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                        sx={{
                            display: { xs: 'block', lg: 'none' },
                            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                        }}
                        className="sidebar"
                    >
                        {drawer}
                    </Drawer>
                    <Drawer
                        variant="permanent"
                        className="responsive-drawer"
                        sx={{
                            display: { xs: 'none', lg: 'block' },
                            '& .MuiDrawer-paper': {
                                boxSizing: 'border-box', width: drawerWidth,
                                height: sideHeight === 'false' ? '88vh' : '100vh'
                                // height: '100vh'
                            },
                        }}
                        open
                    >
                        {drawer}
                    </Drawer>
                </Box>
                {/* <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 3, width: { lg: `calc(100% - ${drawerWidth}px)` } }}
                >

                </Box> */}
            </Box>
        </div>
    )
}

export default SidebarNew
